import styled from 'styled-components'
import React, { useState, useEffect } from 'react'
import useIsMobile from '../../../hooks/useIsMobile'
import Modal from '../../../components/Modal'
import { Close } from '../../../assets/icons'
import { USERS_FILTERS } from '../../../constants'
import { Button } from '../../../components/ui/button'
import theme from '../../../styled/theme'

function UserRolesFilterModal({ showModal, selectedRoles, onClose, onApply }) {
	const isMobile = useIsMobile()
	const [draftRoles, setDraftRoles] = useState(selectedRoles)

	useEffect(() => {
		if (showModal) {
			setDraftRoles(selectedRoles)
		}
	}, [showModal, selectedRoles])

	const handleToggleRole = roleKey => {
		setDraftRoles(prev =>
			prev.includes(roleKey) ? prev.filter(item => item !== roleKey) : [...prev, roleKey]
		)
	}

	if (!showModal) return null

	return (
		<Modal isFullHeight={isMobile}>
			<FilterModalContainer isMobile={isMobile}>
				<FilterCloseButton type="button" onClick={onClose}>
					<Close color={theme.colors.brand.blueOmint} />
				</FilterCloseButton>
				<FilterBody>
					<FilterTitle>Filtros</FilterTitle>
					<FilterSubtitle>Mostrar:</FilterSubtitle>
					<FilterList>
						{USERS_FILTERS.map(item => (
							<FilterItem key={item.key}>
								<RoleCheckbox
									type="checkbox"
									checked={draftRoles.includes(item.key)}
									onChange={() => handleToggleRole(item.key)}
								/>
								<FilterItemLabel>{item.name}</FilterItemLabel>
							</FilterItem>
						))}
					</FilterList>
				</FilterBody>
				<FilterFooter>
					<Button
						label="Aplicar filtros"
						$variant="primary"
						size={isMobile ? 'mobile' : 'large'}
						onClick={() => onApply(draftRoles)}
					/>
				</FilterFooter>
			</FilterModalContainer>
		</Modal>
	)
}


const FilterModalContainer = styled.div`
	width: 100%;
	background: ${props => props.theme.colors.brand.white};
	border-radius: ${props => (props.isMobile ? '24px 24px 0 0' : '24px')};
	padding: ${props => (props.isMobile ? '20px 20px 16px 20px' : '20px 24px 24px 24px')};
	max-width: ${props => (props.isMobile ? 'none' : '420px')};
	height: ${props => (props.isMobile ? '100%' : 'auto')};
	display: flex;
	flex-direction: column;
`

const FilterCloseButton = styled.button`
	border: none;
	background: transparent;
	padding: 0;
	margin-left: auto;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
`

const FilterBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: 8px;
`

const FilterTitle = styled.h2`
	margin: 0;
	font-size: 24px;
	font-weight: 600;
	line-height: 1.2;
	color: ${props => props.theme.colors.text.primaryText};

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		font-size: 42px;
	}
`

const FilterSubtitle = styled.span`
	font-size: 16px;
	font-weight: 600;
	color: ${props => props.theme.colors.text.primaryText};
`

const FilterList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`

const FilterItem = styled.label`
	display: flex;
	align-items: center;
	gap: 12px;
	cursor: pointer;
`

const RoleCheckbox = styled.input`
	width: 16px;
	height: 16px;
	margin: 0;
	accent-color: ${props => props.theme.colors.brand.blueOmint};
`

const FilterItemLabel = styled.span`
	font-size: 16px;
	color: ${props => props.theme.colors.text.primaryText};
`

const FilterFooter = styled.div`
	margin-top: auto;
	padding-top: 24px;
	width: 100%;
	display: flex;
	justify-content: center;
`
export default UserRolesFilterModal